import React from 'react';
import AgedBalancesReport from '../../components/Finance/AgedBalancesReport';

export default function AgedPayables() {
  return <AgedBalancesReport kind="payables" />;
}
